import Pill from './pill';

export default function SmallPill({ onClick, onRemoveClick, removable, children }) {
    return (
        <Pill onClick={onClick} removable={removable} onRemoveClick={onRemoveClick} type="small">{ children }</Pill>
    )
}